import type { BoundaryPartData } from './types';

// Stable empty reference so the map's geometry effect does not re-run every render.
export const EMPTY_PARTS: BoundaryPartData[] = [];
